// Project dependencies
import React, { Suspense } from 'react';
import { createRoot } from 'react-dom/client';
import { usePastDelay } from 'react-lazy-no-flicker';

import '~common/Internationalisation/i18n';
import '@oliasoft-open-source/react-ui-library/dist/global.css';
import App from './app';
import './styles/new-global.css';
import './utils/sentry';

const rootElement = document.getElementById('tlcont');

function Loading() {
  const past_delay = usePastDelay();
  if (!past_delay) { return null; }
  return <div>Loading ...</div>;
}

if (!rootElement) {
  throw new Error('Root element #tlcont was not found');
}

createRoot(rootElement).render(
  <Suspense fallback={<Loading />}>
    <App />
  </Suspense>,
);
